export const minimumDefaults = {
  catering: 800,
  dessert: 250,
}

const calculateMinimums = args => {
  const minimums = {
    main: 200,
    snack: 200,
    side: 200,
    appetizer: 200,
    dessert: 200,
    drink: 100,
    alcohol: 0,
  }

  if (args.delivery) {
    return minimums
  }

  if (args.officePage) {
    return {
      ...minimums,
      main: args.catering,
      snack: args.catering,
      appetizer: args.catering,
      side: args.catering,
      dessert: args.catering,
      drink: args.catering,
    }
  }

  return {
    ...minimums,
    main: args.catering,
    snack: args.catering,
    appetizer: args.catering,
    side: args.catering,
    dessert: args.catering / 2,
    drink: args.cateringTagPage ? 400 : 300,
  }
}

const calculatePrices = args => {
  const prices = {
    dessert: 0,
    main: args.catering / 100, // $8.00
    snack: args.catering / (400 / 3), // $6.00
    appetizer: args.catering / (400 / 3), // $6.00
    side: args.catering / (400 / 3), // $6.00
    drink: args.catering / 800, // $1.00
    alcohol: 0,
  }

  if (args.delivery) {
    return {
      ...prices,
      dessert: args.catering / 240, // $3.33
    }
  }

  if (args.officePage) {
    // return {
    //   ...prices,
    //   main: min / 100, // $8.00
    //   snack: min / (400 / 3), // $6.00
    //   appetizer: min / 200, // $4.00
    //   side: min / 200, // $4.00
    //   dessert: min / (800 * (5 / 23)), // $4.60
    //   drink: min / (800 * (20 / 23)), // $1.15
    // }
  }

  return {
    ...prices,
    dessert: args.catering / (800 / 3), // $3.00
  }
}

const calculateRatio = args => {
  const ratio = 1

  if (args.delivery) {
    return (args.catering * 1) / 4
  }

  if (args.officePage) {
    return args.catering * (5 / 16)
  }

  return ratio
}

export const calculate = args => {
  const eaters = args.eaters || 50
  const ratio = calculateRatio(args)
  const prices = calculatePrices(args)
  const minimums = calculateMinimums(args)

  const estimate = 0

  let city_minimum = args.catering / ratio
  let guest_minimum = args.cateringTagPage ? 400 : city_minimum / 2
  let food_minimum = 0

  if (args.foods?.length) {
    args.foods.forEach(key => {
      guest_minimum = Math.max(guest_minimum, minimums[key.toLowerCase()])
      food_minimum += prices[key.toLowerCase()] * eaters
    })
  } else {
    food_minimum += prices.drink * eaters
  }

  const bc_minimum = Math.max(guest_minimum, food_minimum)

  return Math.ceil(bc_minimum / 10) * 10
}

export function getMiles(i) {
  return Math.ceil(i * 0.000621371192)
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
